<!--
	Copyright 2023 HALBY
	See LICENSE file for details.
 -->

<script lang="ts">
	import OctaCard from './OctaCard.svelte';
	import styleVariables from '$lib/style-variables';
	import { onMount } from 'svelte';
	import { getMaruFont } from '$lib/services/font-service';
	import { page } from '$app/stores';

	export let title: string | undefined = undefined;

	let maru_font: string | null = null;
	onMount(() => {
		maru_font = getMaruFont($page.url);
	});
</script>

<div class="outer">
	<div class="octa-card-wrapper">
		<OctaCard bevelSize={45} thickness={2} color={styleVariables.colorAccent}>
			<div class="inner-block in-octa">
				{#if title}
					<h1 class="title {maru_font}">{title}</h1>
					<hr class="hr-standard" />
				{/if}
				<slot></slot>
			</div>
		</OctaCard>
	</div>
	<div class="inner-block out-octa">
		{#if title}
			<h1 class="title {maru_font}">{title}</h1>
			<hr class="hr-standard" />
		{/if}
		<slot></slot>
	</div>
</div>

<style lang="scss">
	@use '$lib/assets/css/mq-settings' as mq;
	@use '$lib/assets/css/variables' as var;

	.outer {
		width: 100%;
		max-width: 1280px;
		padding: 80px 96px;
		@include mq.mq($until: desktop) {
			padding: 0;
		}
	}
	.inner-block {
		width: 100%;
		background-color: white;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.title {
		width: 100%;
		text-align: center;
		font-size: 40px;
		font-weight: 700;
		color: var.$color-header-font;
		padding-top: 12px;
		line-height: 80px;
	}
	@include mq.mq($from: desktop) {
		.out-octa {
			display: none;
		}
	}
	@include mq.mq($until: desktop) {
		#main {
			padding: 0;
		}
		.octa-card-wrapper {
			display: none;
		}
	}
</style>
